import { render, staticRenderFns } from "./group-notice.vue?vue&type=template&id=3192db97&"
import script from "./group-notice.js?vue&type=script&lang=js&"
export * from "./group-notice.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports